
    export default 
    {
    "top_stores": {
        "store_authorized_tip": "La tienda necesita ser reautorizada. Por favor, dirígete a <a href=\"/app/settings?id=4\">Ajustes - Cuenta</a> para actualizar la autorización. De lo contrario no podrás manejar la tienda correctamente con Dsers"
    }
}